
import { graphql, PageProps, useStaticQuery } from "gatsby"
import { IMissionSection, IHistorySection, IAboutUsSection, IEventsSection, ITimelineSection, IManagmentSection, IAdressDataSection, ILawInformationsSection, IContactAccountsSection, IPostsSection, IPressInformationsSpecialistSection, IDownloadableAssetsSection } from "interfaces/sections"
import { Brand, Csr, Information, Person, Post } from "types"
import OpenGraph from "types/opengraph"
import { StringMappingType } from "typescript"
import Media from "../types/media"


const usePosts = (categorySlug: string, limit?: number): Post[] => {
  const { allWpPost } = useStaticQuery(graphql`
  query {
    allWpPost(sort: { date: DESC } ) {
      nodes {
        id
        slug
        title
        featuredImage {
          node {
            id
            sourceUrl
            altText
            title
            gatsbyImage: localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                  quality: 100
                  layout: FULL_WIDTH
                )
              }
            }
          }
        }
        postOptions{
          title,
          date
          url
          description
          author{
            ...on WpPerson{
              personOptions{
                name,
                position,
                email,
                image{
                  mediaItemUrl
                  mimeType
                  mediaType
                  altText
                  title
                  gatsbyImage: localFile {
                    childImageSharp {
                      gatsbyImageData(
                        placeholder: BLURRED
                        formats: [AUTO, WEBP]
                      )
                    }
                  }
                }
              }
            }
            
           
          }
          textimage {
            mediaItemUrl
            mimeType
            mediaType
            altText
            title
            gatsbyImage: localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
          abovetextimage{
            mediaItemUrl
            mimeType
            mediaType
            altText
            title
            gatsbyImage: localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
        categories{
          nodes{
            id
            slug
          }
        }
      }
  }}`)

  const filterWpPosts = allWpPost.nodes.filter((post: any) => {
    return post.categories.nodes.find((category: any) => {
      return category.slug == categorySlug
    })
  })
  if (limit) {
    return filterWpPosts.slice(0, limit)
  } else {
    return filterWpPosts
  }


}

export default usePosts